/**
 * Where a conversation's summary goes, from the width of its pane: in the free gutter beside the
 * transcript (`gutter`), beside a transcript moved aside to make room (`shift`), or nowhere but a
 * popover from the title bar (`overlay`).
 */
export type ThreadSummaryMode = 'gutter' | 'shift' | 'overlay';

/** The summary card's width and its distance from the pane's right edge. */
export const THREAD_SUMMARY_WIDTH = 300;
export const THREAD_SUMMARY_INSET = 16;
/** The transcript's text column (`max-w-conversation`, 52rem, less its 1.75rem side padding). */
const THREAD_COLUMN_WIDTH = 776;

/** The space left on each side of the transcript's column decides where the summary goes. */
export function threadSummaryMode(paneWidth: number): ThreadSummaryMode {
  const gutter = (paneWidth - THREAD_COLUMN_WIDTH) / 2;
  if (gutter < 180) return 'overlay';
  if (gutter < 400) return 'shift';
  return 'gutter';
}

/** How far the transcript moves left to make room for the pinned summary (`shift` only). */
export function threadContentShift(mode: ThreadSummaryMode, pinned: boolean): number {
  return pinned && mode === 'shift' ? -(THREAD_SUMMARY_WIDTH + THREAD_SUMMARY_INSET) / 2 : 0;
}
